import React from 'react'
import Header from '../componets/header/header'
import Footer from '../componets/footer/footer'
import bolg1 from '../../assets/blog1.webp'
import bolg2 from '../../assets/blog2.webp'
import bolg3 from '../../assets/blog3.webp'
import bolg4 from '../../assets/blog4.webp'
import bolg5 from '../../assets/blog5.webp'
import bolg6 from '../../assets/blog6.webp'
import bolg7 from '../../assets/blog7.webp'
import bolg8 from '../../assets/blog8.webp'
import bolg9 from '../../assets/blog9.webp'
import bolg10 from '../../assets/blog-10.webp'
import bolg11 from '../../assets/blog11.webp'
import bolg12 from '../../assets/blog12.webp'
import bolg13 from '../../assets/blog13.webp'


// @ts-ignore: allow side-effect CSS import without type declarations
import './blogpage.css'
import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'
// import { Helmet } from 'react-helmet-async'
import { Helmet } from 'react-helmet'
function Blogpage() {
    const navigate = useNavigate();
    return (
        <div>
            <Helmet>
                <title>Best Professional Courses in India | Meantoir Global Academy
                </title>
                <meta
                    name="description"
                    content="Explore the best professional courses in India at Meantoir Global Academy, including EA,      
CFE, CFS, CFM, and Diploma in IFRS exam preparation"
                />
                <link rel="canonical" href={`https://meantoir.com/blogs`} />
            </Helmet>
            <Header />
            <div className="about-page">
                <div className="blog-container">
                    <h2 className="homepage-heading">Latest Blogs</h2>
                    <div className="blog-grid">

                        <div className="blog-card" >
                            <img className="blog-image" src={bolg1} alt='Top 5 Reasons to Become an Enrolled Agent' />
                            <div className="blog-content">
                                <h3 className="blog-heading">Top 5 Reasons to Become an Enrolled Agent</h3>
                                <p className="blog-desc">If you’re in tax accounting and looking to capitalize on the hot job market, earning your Enrolled
                                    Agent designation is the best way to make the next step in your career a big one. </p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog1`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg2} alt='How Long Does it Take to Become an Enrolled Agent?' />
                            <div className="blog-content">
                                <h3 className="blog-heading">How Long Does it Take to Become an Enrolled Agent?</h3>
                                <p className="blog-desc">Based on over 20 years’ experience preparing candidates, we recommend you aim to pass the Enrolled Agent exam in one year. Ultimately, how long it takes to become an Enrolled Agent  ....</p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog2`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg3} alt='An Ultimate Guide for Enrolled Agent Jobs and Enrolled Agent Salary' />
                            <div className="blog-content">
                                <h3 className="blog-heading">An Ultimate Guide for Enrolled Agent Jobs and Enrolled Agent Salary</h3>
                                <p className="blog-desc">Earning your Enrolled Agent certification is the ideal way to take the next significant step in your career if you work in tax accounting and want to take advantage of the booming employment market.</p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog3`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg4} alt='How to become a Finance Specialist: Elevate your professional development with our CFS certification' />
                            <div className="blog-content">
                                <h3 className="blog-heading">How to become a Finance Specialist: Elevate your professional development with our CFS certification</h3>
                                <p className="blog-desc">Finance Specialists, also known as Financial Analysts, play a pivotal role in managing financial processes... </p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog4`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg5} alt='How will the CFS® help you in your job search?' />
                            <div className="blog-content">
                                <h3 className="blog-heading">How will the CFS® help you in your job search?</h3>
                                <p className="blog-desc">People who found a job in finance after successfully completing Certified Finance Specialist® (CFS®) applied the same determination to their job search </p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog5`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg6} alt='Best Courses in Kerala: A Guide to Quick Job Placement' />
                            <div className="blog-content">
                                <h3 className="blog-heading">Best Courses in Kerala: A Guide to Quick Job Placement</h3>
                                <p className="blog-desc">The best courses in Kerala designed to equip students with the skills needed for high-demand careers are Oil and Gas Drilling Technology, Oil and Gas Engineering. </p>

                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog6`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg7} alt='Best Job oriented courses after plus two Kochi, Kerala' />
                            <div className="blog-content">
                                <h3 className="blog-heading">Best Job oriented courses after plus two Kochi, Kerala</h3>
                                <p className="blog-desc">A list of 19 job oriented courses to join after plus two(+2) in Kochi, Kerala. Discover a diverse range of educational pathways designed to equip students with practical </p>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog7`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg8} alt='Why CFE (Certified Fraud Examiner) is the Ultimate Career Choice in 2025 and Beyond' />
                            <div className="blog-content">
                                <h3 className="blog-heading">Why CFE (Certified Fraud Examiner) is the
                                    Ultimate Career Choice in 2025 and Beyond </h3>
                                <p className="blog-desc">Fraud is rising faster than ever - powered by digital payments, AI-driven scams, and corporate
                                    vulnerabilities. Companies across India and the world are strengthening their fraud teams at
                                    record speed.  </p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog8`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg9} alt='Top Fraud-Related Certifications in 2025: Why the CFE Is the Best & How to Pass It in India' />
                            <div className="blog-content">
                                <h3 className="blog-heading">Top Fraud-Related Certifications in 2025: Why
                                    the CFE Is the Best & How to Pass It in India </h3>
                                <p className="blog-desc">Fraud is rising faster than ever - powered by digital payments, AI-driven scams, and corporate
                                    vulnerabilities. Companies across India and the world are strengthening their fraud teams at
                                    record speed</p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog9`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg10} alt='IFRS Diploma: The Ultimate Guide to Global Accounting Careers, Salary & Job Opportunities' />
                            <div className="blog-content">
                                <h3 className="blog-heading">IFRS Diploma: The Ultimate Guide to Global Accounting
                                    Careers, Salary & Job Opportunities </h3>
                                <p className="blog-desc">In today’s hyper-globalized business environment, International Financial Reporting
                                    Standards (IFRS) are no longer optional they are mandatory knowledge for accounting and
                                    finance professionals. </p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog10`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg11} alt='CFCS: The Ultimate Guide to Global Accounting Careers, Salary & Job Opportunities' />
                            <div className="blog-content">
                                <h3 className="blog-heading">CFCS: The Ultimate Guide to Global Accounting Careers, Salary & Job Opportunities</h3>
                                <p className="blog-desc">The financial world is changing rapidly. With increasing cases of money laundering, fraud, cybercrime, terrorist financing, corruption, and financial misconduct, organizations worldwide are
                                    searching for professionals who can identify, prevent, investigate, and manage financial crimes. </p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog11`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg12} alt='CFCS: The Ultimate Guide to Global Accounting Careers, Salary & Job Opportunities' />
                            <div className="blog-content">
                                <h3 className="blog-heading">CAMS: The Ultimate Guide to Global AML Careers, Salary & Job Opportunities</h3>
                                <p className="blog-desc">Certified Anti-Money Laundering Specialist (CAMS) Career Guide for Accounting, Finance & Banking Professionals
                                    Introduction: Why CAMS Certification Is Becoming One of the Most Valuable Global Finance Certifications
                                </p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog12`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="blog-card" >
                            <img className="blog-image" src={bolg13} alt='CTP: The Ultimate Guide to Global Treasury Careers, Salary & Job Opportunities' />
                            <div className="blog-content">
                                <h3 className="blog-heading">CTP: The Ultimate Guide to Global Treasury Careers, Salary & Job Opportunities</h3>
                                <p className="blog-desc">Certified Treasury Professional (CTP) Career Guide for Finance, Accounting & Corporate Treasury Professionals
                                    Introduction: Why CTP Is Becoming One of the Most Valuable Global Finance Certifications
                                </p>
                                {/* <p className="blog-date">April 10, 2025</p> */}
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <Button onClick={() =>
                                        navigate(`/blog13`)
                                    }>
                                        Read More
                                    </Button>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Blogpage
